import { render, staticRenderFns } from "./PresenceForm.vue?vue&type=template&id=a03cd838&scoped=true"
import script from "./PresenceForm.vue?vue&type=script&lang=js"
export * from "./PresenceForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a03cd838",
  null
  
)

export default component.exports